module.exports = __webpack_public_path__ + "img/verified-match-icon.svg";